module.exports = __webpack_public_path__ + "img/people.99da7e4e.svg";